<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header d-block">
                <h1 class="text">{{this.$route.meta.title}}</h1>
                <div class="card-header-action mt-3 card-report">
                    <button v-b-modal.bv-modal-Sorting type="button" class="btn btn-light">
                        Selected statistics from {{sorting_date}}
                        <i class="ml-2 align-middle uil uil-angle-down"></i>
                    </button>
                </div>
            </div>

            <div class="section-body">
                <b-row class="mt-4">
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-user-arrows"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Agent</h5>
                                     <p class="mb-0">Total Agent</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.agents}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-ticket"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Slot Purchases</h5>
                                     <p class="mb-0">Total Slot Purchases</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.slots_purchases}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="3">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                 <div class="cst-icon">
                                    <i class="w-100 uil uil-ticket"></i>
                                 </div>
                                 <div class="cst-cnt mt-3">
                                     <h5 class="mb-0">Slot Sale</h5>
                                     <p class="mb-0">Total Slot Sale</p>
                                 </div>
                                 <div class="cst-val">
                                     <h4 class="w-100 mb-0">{{reports.slots_sales}}</h4>
                                 </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="12">
                        <h5 class="mb-4">Agents Statistic</h5>
                        <b-card no-header class="card-statistic bdr-15">
                            <canvas id="chart-agents"></canvas>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </section>

        <b-modal id="bv-modal-Sorting" centered hide-header hide-footer>
            <div class="form-row mt-4">

                <div class="form-group col-md-12">
                    <label>Report Type</label>
                    <v-select :clearable="false" label="label" :reduce="sorting_type => sorting_type.value" v-model="sorting_report.date_type" :options="sorting_type"></v-select>
                </div>

                <div class="form-group col-md-12">
                    <label>Chart Type</label>
                    <v-select :clearable="false" label="label" :reduce="type_chart => type_chart.value" v-model="sorting_report.chart_type" :options="type_chart"></v-select>
                </div>

                <template v-if="sorting_report.date_type === 'custom'">
                    <div class="form-group col-md-12">
                        <label>Start Date</label>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="uil uil-calendar-alt"></i>
                                </div>
                            </div>
                            <datetime v-model="sorting_report.start_date" type="date" input-class="form-control"></datetime>
                        </div>
                    </div>

                    <div class="form-group col-md-12">
                        <label>End Date</label>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="uil uil-calendar-alt"></i>
                                </div>
                            </div>
                            <datetime :min-datetime="sorting_report.start_date" v-model="sorting_report.end_date" type="date" input-class="form-control"></datetime>
                        </div>
                    </div>
                </template>

                <div class="form-group col-md-12 mb-0">
                    <button v-on:click="sortingReports()" class="btn btn-new"><i class="uil uil-search mr-1"></i> Search Reports</button>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import moment from 'moment'
    import { Datetime } from 'vue-datetime';
    import vSelect from 'vue-select'
    import Chart from 'chart.js';
    import chartData from '../../../utils/chart-data.js';

    export default {
        data() {
            return {
                sorting_date:'',

                chart_agents_format: chartData.AgentsChart,
                chart_agents: [],
            }
        },
        mounted(){
            this._getDistributorReports()
        },
        components: {
            Datetime,
            vSelect,
        },
        computed:{
            ...mapState('DashboardControl', {
                reports: state => state.reports,
                type_chart: state => state.type_chart,
                sorting_type: state => state.sorting_type,
                sorting_report: state => state.sorting_report,
            }),
        },
        filters: {
            formatDate: function(val){
                return moment(String(val)).format('DD MMMM YYYY')
            }
        },
        methods:{
            ...mapActions('DashboardControl', ['getReportsDistributor']),
            ...mapMutations('DashboardControl', ['CLEAR_SORTING_REPORT']),
            
            sortingType: function(){
                if(this.sorting_report.date_type != 'custom'){
                    this.sorting_type.forEach(data => {
                        if(data.value == this.sorting_report.date_type){
                            this.sorting_date = data.label
                        }
                    });
                }else{
                    this.sorting_date = moment(String(this.sorting_report.start_date)).format('DD MMMM YYYY')   + ' - ' + moment(String(this.sorting_report.end_date)).format('DD MMMM YYYY')
                }
            },
            sortingReports: function(){
                this._getDistributorReports();
                this.$bvModal.hide('bv-modal-Sorting')
            },
            _getDistributorReports: function(){
                this.getReportsDistributor().then(() => {
                    this.sortingType()
                    this.createChartAgents('chart-agents', this.chart_agents_format)
                    this.setDataChartAgents()
                });
            },
            createChartAgents(chartId, chartData) {
                const ctx = document.getElementById(chartId);
                this.chart_agents = new Chart(ctx, {
                    type: chartData.type,
                    data: chartData.data,
                    options: chartData.options,
                });
            },
            clearChartAgents(chart){
                chart.data.labels.splice(0,chart.data.labels.length);
                chart.data.datasets.forEach((dataset) => {
                    dataset.data.splice(0,dataset.data.length);
                });
                chart.update();
            },
            setDataChartAgents(){
                this.clearChartAgents(this.chart_agents)
                for( var i = 0; i < this.reports.agents_chart.length; i++ ){
                    this.addDataChartAgents(this.chart_agents,this.reports.agents_chart[i].date, this.reports.agents_chart[i].total);
                }
            },
            addDataChartAgents(chart,label,data){
                chart.data.labels.push(label);
                chart.data.datasets.forEach(dataset => {
                    dataset.data.push(data);
                });
                chart.update();
            },
        },
        destroyed(){
            this.CLEAR_SORTING_REPORT()
        }
    }
</script>